/**
 * Top-level :playersId segments that exist on the team strip but have no branch in SelectedPlayerRouter.
 * Browser history can land here while selectedPlayer is still set (empty player shell).
 * @see `.cursor/rules/rfcs/0004-todo-browser-back-teams-player-navigation.md`
 */
export const TEAM_ONLY_PLAYERS_IDS = ['dashboard'] as const;

/** First segment under /players/:playersId/... (e.g. dashboard, keyMetrics). */
export function getPlayersTopLevelSegment(pathname: string): string | undefined {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] !== 'players' || parts.length < 2) return undefined;
  return parts[1];
}

export function shouldClearSelectedPlayerForUrl(
  pathname: string,
  selectedPlayerName: string | undefined | null,
): boolean {
  if (!selectedPlayerName) return false;
  const top = getPlayersTopLevelSegment(pathname);
  if (!top) return false;
  return (TEAM_ONLY_PLAYERS_IDS as readonly string[]).includes(top);
}
